// ----------------------------------------------------------------------
// <copyright file="Izenda.GridItemOverlay.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var Motion = require('react-motion').Motion;
  var spring = require('react-motion').spring;

  var observer = require('mobx-react').observer;
  var observablePropTypes = require('mobx-react').propTypes;
  var classnames = require('classnames');

  const { assign } = require('lodash/fp');
  /**
   * Grid item overlay box showing when user interacting with a grid item
   */
  var GridItemOverlay = React.createClass({
    firstRendering: true,
    propTypes: {
      layoutStore: observablePropTypes.observableObject
    },
    render: function() {
      var props = this.props;
      var layoutStore = props.layoutStore;
      var layoutItem = layoutStore.overlayItem;
      var position = layoutStore.overlayPosition;
      var show = layoutItem && layoutItem.isInteracting;
      var isMoving = layoutItem && layoutItem.isMoving;
      var needRenderStatic = this.firstRendering;

      this.firstRendering = !layoutStore.isInteracting;

      var isCollided = layoutItem && layoutStore.detectCollision(layoutItem.id, position);
      var isSwappable =
        layoutItem && isMoving && layoutStore.allowSwap && layoutStore.detectSwap(layoutItem.id, position);

      var className = classnames('GridItemOverlay', props.className, {
        'GridItemOverlay-valid': !isCollided || isSwappable,
        'GridItemOverlay-invalid': isCollided && !isSwappable
      });
      var render = needRenderStatic ? this.renderStatic : this.renderMotion;

      return render(position, show, className);
    },
    renderStatic: function(position, show, className) {
      var style = assign(
        {
          display: show ? 'block' : 'none',
          position: 'absolute'
        },
        position
      );

      return <div className={className} style={style} />;
    },
    renderMotion: function(position, show, className) {
      var springConfig = {
        precision: 0.3,
        damping: 27,
        stiffness: 250
      };
      var positionStyle = {
        top: spring(position.top, springConfig),
        left: spring(position.left, springConfig),
        width: spring(position.width, springConfig),
        height: spring(position.height, springConfig)
      };

      return (
        <Motion style={positionStyle}>
          {function(interpolatingStyle) {
            var style = assign(
              {
                display: show ? 'block' : 'none',
                position: 'absolute',
                transformStyle: 'flat'
              },
              interpolatingStyle
            );

            return <div className={className} style={style} />;
          }}
        </Motion>
      );
    }
  });

  module.exports = observer(GridItemOverlay);
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/GridLayout/Izenda.GridItemOverlay.jsx